import {
    mapActions, mapMutations, mapState, mapGetters,
} from 'vuex'

export default {
    computed: {
        ...mapState({
            me: state => state.auth.user,
            authError: state => state.auth.error,
        }),
        ...mapGetters({
            isAuth: 'auth/isAuth',
        }),
    },
    methods: {
        ...mapMutations({
            authCleanError: 'auth/CLEAN_ERROR',
        }),
        ...mapActions({
            signin: 'auth/signin',
            signout: 'auth/signout',
        }),
    },
}
